import get from 'lodash/get';
import { api } from '$app/api';

export function getGarageById(garageId) {
  return api
    .get(`/garages/${garageId}`)
    .then((res) => res.data)
    .then((garage) => {
      garage.garageDeliveryOption = get(garage, 'deliveryOptions[0].deliveryOption');
      return garage;
    });
}

export function putGarageById(garageId, data) {
  return api.put(`/garages/${garageId}`, data);
}

export function updateRules(garageId, timetableId, rules) {
  return api
    .post(`/garages/${garageId}/rules`, {
      timetableId,
      rules,
    })
    .then((res) => res.data);
}

export function getRulesByTimetableId(timetableId) {
  return api
    .post(`timetable/rules`, {
      eventType: 'GetTimetableRulesRequest',
      body: {
        timetableId,
      },
    })
    .then((res) => get(res, 'data[0].rules', []));
}
